module.exports = __webpack_public_path__ + "img/AISuggested.55a5a1fd.png";